export default __webpack_public_path__ + "static/media/only-points-gift-card.f90b0079.png";